import { MutableRefObject, useRef } from 'react';

import { networkCallWithApisauceWithHeaders } from '@nw/shared/data-access';

import FileUploadService from '../../services/FileUploadService';
import FileUploadAPIService from '../../services/FileUploadService/index.api';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

interface RefreshAuthTokensContextType {
  refreshTokenApi: (requestObject: unknown) => Promise<unknown>;
  getAccessToken: () => string;
  getRefreshToken: () => string;
}

const useFileUploadConfigServices = (
  baseURL?: string,
  refreshAuthTokensHook?: () => RefreshAuthTokensContextType
) => {
  const accountsFallback = useAccountsRefreshAuthTokens();
  const customAuthContext = refreshAuthTokensHook ? refreshAuthTokensHook() : null;

  const authContext = customAuthContext ?? accountsFallback;

  const { refreshTokenApi, getAccessToken, getRefreshToken } = authContext;
  const fileUploadConfigRef: MutableRefObject<FileUploadService | null> =
    useRef(null);

  if (fileUploadConfigRef.current === null) {
    fileUploadConfigRef.current = new FileUploadAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      }),
      baseURL
    );
  }
  return { fileUploadConfigServices: fileUploadConfigRef.current };
};

export { useFileUploadConfigServices };
